export enum RelativeDatePlaceholdersEnum {
    ExecutionDate = '{@ExecutionDate}',
    LastExecutionDate = '{@LastExecutionDate}',
    DayBeforeExecution = '{@DaysBeforeExecution:1}',
    WeekBeforeExecution = '{@WeeksBeforeExecution:1}',
    MonthBeforeExecution = '{@MonthsBeforeExecution:1}',
    YearBeforeExecution = '{@YearsBeforeExecution:1}'
}
